import React, {useState,useEffect} from 'react';
import {Grid,} from '@material-ui/core'

import {DashboardHeader} from '../../../components'
import './style.scss'
import DataTable from '../../../components/dataTable/servicesSelectionDatatable'
import { bidsHeadCells} from './constant'
import {bidsAgainst} from "../../../environment";
import HttpService from "../../../services/http.service";
import {getUserDataFromLocalStorage} from "../../../services/utils";
function Index() {
  const [loading, setLoading] = useState(true)
  const [bid, setBid] = useState([])
  const user = getUserDataFromLocalStorage()
    useEffect(() => {
        setLoading(true)
        HttpService.post('bids/bidsIDid/',{ssoId: user.ssoId}).then(res => {
          if (res) {
            setBid(res.data)
            setLoading(false)
          }
        });
      }, []);
  return (
    <Grid container direction={'column'} className='p-20 content-main-container' >
      <DashboardHeader pageTitle={'My Bids'}/>
      <div className="mt-20">
        {
          // (loading) ? <Loader/> :
          //   (usersList && usersList.resp.length > 0) ?
          !loading &&
          <DataTable
            // data={{rows: usersList?.resp, column: headCells,}}
            // data={{rows: data, column: servicesHeadCells,}}
            data={{rows: bid, column: bidsHeadCells,}}
            // vendor={activeCat === 'vendor'}
            tableName={bidsAgainst}
            showAddOption={false}

            // loading={loading}
            // pagination={{
            //   totalRows: usersList?.pagination?.rowCount,
            //   pageSize: pageSize,
            //   onPageSizeChange: onPageSizeChange,
            //   pageNo: pageNo - 1,
            //   onPageChange: onPageChange
            // }}
          />
          // :
          //     (usersList && !usersList.resp.length > 0 && !loading) ? <NoData text={"no data available"}/>
          //       : <Loader/>
        }
      </div>

    </Grid>
  );
}

export default Index;
